import { useCallback, useState } from 'react';

import { IApiError, NotificationListEnum } from '../types/shell';
import notification from '../utils/notification';
import { handleApiError } from '../utils/ui';

interface IOptions {
  request: (resolve: (value?: unknown) => void, reject: (reason?: unknown) => void) => void;
  successText: string;
  errorText: string;
  onClose?: () => void;
}

export const useDeleteWithConfirm = ({ request, successText, errorText, onClose }: IOptions) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);

  const cancel = useCallback(() => setIsOpen(false), []);

  const confirm = useCallback(() => {
    setIsDeleting(true);

    return new Promise(request)
      .then(() => {
        notification.success(NotificationListEnum.Success, { content: successText });
        setIsDeleting(false);
        setIsOpen(false);
        onClose?.();
      })
      .catch((error: IApiError) => {
        setIsDeleting(false);
        setIsOpen(false);
        handleApiError(errorText)(error);
      });
  }, [request, successText, errorText, onClose]);

  return { isOpen, isDeleting, open, cancel, confirm };
};

export default useDeleteWithConfirm;
